import { useActivePage } from '@hooks/useActivePage';
import { Typography } from '@mui/material';
import Button, { buttonClasses, ButtonProps } from '@mui/material/Button';
import { LinkProps } from '@mui/material/Link';
import { alpha, styled, SxProps, Theme } from '@mui/material/styles';
import { PageId } from '@shared/protos/routes';

type MobileNavBarButtonProps = {
  icon: string;
  label: string;
  pageId?: PageId;
  target?: LinkProps['target'];
  sx?: SxProps<Theme>;
};

const StyledButton = styled(Button)(({ theme }) => ({
  height: 55,
  width: 55,
  dispaly: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 0,
  margin: 0,
  padding: 0,
  lineHeight: 1,
  fontSize: 18,
  [`${buttonClasses.disabled}`]: {
    color: alpha(theme.palette.text.secondary, 0.3),
  },
  '&:focus': {
    backgroundColor: 'transparent !important',
  },
  '&:hover': {
    backgroundColor: 'transparent !important',
  },
}));

export function MobileNavBarButton({ icon, label, pageId, sx, ...buttonProps }: MobileNavBarButtonProps & ButtonProps) {
  const { pageId: activePageId } = useActivePage();

  return (
    <StyledButton
      {...buttonProps}
      disableRipple
      disableTouchRipple
      disableFocusRipple
      disableElevation
      sx={{ color: pageId === activePageId ? 'text.primary' : 'text.secondary', ...sx }}
    >
      <i className={icon} />
      <Typography fontSize={10} fontWeight={700}>
        {label}
      </Typography>
    </StyledButton>
  );
}
